import { useState, useMemo, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box } from "@mui/system";
import { Table, Dropdown, Menu } from "antd";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch,useSelector } from "react-redux";
import { downloadRequest } from "../../../store/actions/organization";
import { DropdownFilterWithSearchAndCheckbox,DropdownFilterWithSearch,DropdownFilterWithDateRangePicker } from "../../../components/DropdownFilter";
import CreateOrganization from "../../../pages/Organization/CreateOrganization";
import { DeleteOrganizationModal } from "../../../pages/Organization/organizationModel";
import { deleteOrganizationEndPoint } from "../../../configuration";
import { fetchRequest, setCurrentModal,updatePaginationRequest } from "../../../store/actions/organization";
import { Button } from "@vds/buttons";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import CustomModal from "../../../components/CustomModal";
import ToastNotification from "../ToastNotification";
import { getRandomUUID } from "../../../Token";
import dayjs from "dayjs";
const OrganizationTable = (props) => {
  const {
  //  organizationList,
    alarmCounts,
    isLoadingAlarmCount,
    setSelectedOrganization,
    selectedOrganization,
    permissions,
    searchOrg,
    currentModal,
  } = props;
  const [checkboxItems, setCheckboxItems] = useState([]);
  const [searchOrgName, setOrgName] = useState(searchOrg);
  const [locationFilter, setLocationFilter] = useState([]);
  const [alertFilter, setAlertFilter] = useState([]);
  const [orgPopupVisible, setOrgPopupVisible] = useState(false);
  const [showDeleteRole, setShowDeleteRole] = useState(false);
  const [deleteOrgConfirmed, setDeleteOrgConfirmed] = useState(false);
  const [showDeleteOrg, setShowDeleteOrg] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [isAsc, setAsc] = useState(true);
  const [formData, setFormData] = useState({
    orgName: "",
  });

  const { shouldUpdate, count, organizationList, currentPage, pageSize,isLoading } =
      useSelector((state) => ({
        shouldUpdate: state?.organization?.shouldUpdate,
        count: state?.organization?.data?.total,
        organizationList: state?.organization?.data?.organization,
        currentPage: (state?.organization?.filter?.pageNo || 0) + 1,
        pageSize: state?.organization?.filter?.limit,
        isLoading:state?.organization?.isLoading,
      }));
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      setOrgName([]);
      setLocationFilter([]);
      setAlertFilter([]);
    };
  }, []);
  useEffect(() => {
     dispatch(
      updatePaginationRequest({
        name: { value: "", sort: "" },
        pageNo: 0,
        lastUpdatedto: "", 
        lastUpdatedfrom: "",
      })
    );
     dispatch(fetchRequest());
    }, [user?.accountId]);
     useEffect(() => {
        dispatch(updatePaginationRequest({
          limit: 10,
        }));
      }, []);

  useEffect(() => {
    if (organizationList?.length > 0 && Object.keys(alarmCounts).length > 0) {
      setCheckboxItems(
        Array.from(
          new Set(
            organizationList.map(
              (item) =>
                (alarmCounts[item.id]?.warningCount || 0) +
                (alarmCounts[item.id]?.errorCount || 0)
            )
          )
        )
          .sort((a, b) => a - b)
          .map((totalAlerts) => ({
            text: `${totalAlerts} ${totalAlerts === 1 ? "Alert" : "Alerts"}`,
            value: totalAlerts.toString(),
          }))
      );
    }
  }, [organizationList, alarmCounts]);
  const uniqueCheckboxItems = useMemo(() => {
    const items = new Map();

    organizationList?.forEach((org) => {
      const orgName = org?.tags?.[0]?.org_name?.toLowerCase() || "";

      if (!orgName) return;
      if (items.has(orgName)) {
        const count = items.get(orgName).count + 1;
        items.set(orgName, {
          count,
          items: [
            ...items.get(orgName).items,
            {
              text: `${orgName} (${count})`,
              value: `${org.id}`,
              originalName: orgName,
              checked: false,
            },
          ],
        });
      } else {
        items.set(orgName, {
          count: 1,
          items: [
            {
              text: orgName,
              value: `${org.id}`,
              originalName: orgName,
              checked: false,
            },
          ],
        });
      }
    });
    return Array.from(items.values()).flatMap((group) => group.items);
  }, [organizationList]);

  const editOrganization = (record) => {
    setSelectedOrganization(record);
    if (record) {
      setOrgPopupVisible(true);
    }
  };
  
  const handleDownload = () => {
    try {
      dispatch(downloadRequest("organizationList"));
      setNotificationProps({
        type: "success",
        message: "Export",
        description: "Export completed successfully.",
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } catch (error) {
      setNotificationProps({
        type: "error",
        message: "Export",
        description: error.message || "Unable to serialize unrecognized input.",
        duration: 5,
        style: { backgroundColor: "#FFECE0", color: "black" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    }
  };
  const handleOrgCreatedAdd = () => {
     setSelectedOrganization(null);
    setOrgPopupVisible(false);
    dispatch(fetchRequest());
  };
  const onConfirm = async () => {
    setDeleteOrgConfirmed(true);
    setShowDeleteOrg(false);
    const response = await fetch(deleteOrganizationEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tagId: selectedOrganization?.id,
      }),
    });
    if (response?.status === 200 || response?.status === 204) {
      setFormData({ orgName: "" });
      setSelectedOrganization(null);
      setNotificationProps({
        type: "success",
        message: "Delete Organization",
        description: `Organization "${(() => {
          const name = selectedOrganization?.tags?.[0]?.org_name ||
            selectedOrganization?.org_name ||
            selectedOrganization?.tags?.[0]?.name ||
            selectedOrganization?.name ||
            'Unknown Organization';
          return name;
        })()}" deleted successfully`,
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
    } else {
      setNotificationProps({
        type: "error",
        message: "Delete Organization",
        description: "failed",
        duration: 1,
        style: { backgroundColor: "#FFECE0", color: "#155724" },
      });
    }
    setShowNotification(true);
    setTimeout(() => {
      setShowNotification(false);
    }, 1000);
    setDeleteOrgConfirmed(false);
    handleOrgCreatedAdd();
    setShowDeleteRole(false);
    dispatch(setCurrentModal(false))
  };
  const onExit = () => {
    setDeleteOrgConfirmed(false);
    setShowDeleteOrg(false);
    dispatch(setCurrentModal(false))
    //navigate(-1);
  };
  const closeorgPopup = () => {
    setOrgPopupVisible(false);
    setSelectedOrganization(null)
  };
  const deleteOrganization = (record) => {
    setSelectedOrganization(record);
    setDeleteOrgConfirmed(record);
    setShowDeleteOrg(true);
    dispatch(setCurrentModal(true))

  };
  function dateFormatWithAt(timestamp) {
  const updatedOnDate = new Date(timestamp);
  return `${(updatedOnDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${updatedOnDate
    .getDate()
    .toString()
    .padStart(2, "0")}-${updatedOnDate.getFullYear()} at ${updatedOnDate
    .toLocaleTimeString("en-US", {
      hour12: false,
    })
    .toLowerCase()}`;
}

const filteredData=organizationList;

  // const sortedData = organizationList?.sort((a, b) => {
  //   const orgA = a?.tags?.[0]?.org_name?.toLowerCase() || a?.name?.toLowerCase() || a?.org_name?.toLowerCase() || "";
  //   const orgB = b?.tags?.[0]?.org_name?.toLowerCase() || b?.name?.toLowerCase() || b?.org_name?.toLowerCase() || "";
  //   return isAsc ? orgA.localeCompare(orgB) : orgB.localeCompare(orgA);
  // });
  // const filteredData = useMemo(() => {
  //   return sortedData?.filter((item) => {
  //     if (!item) return false;

  //     const orgName = (
  //       item.tags?.[0]?.org_name ||
  //       item.tags?.[0]?.name ||
  //       item.org_name ||
  //       item.name
  //     )?.toLowerCase();

  //     if (!orgName) return false;
  //     const passesOrgFilter =
  //       !searchOrgName?.length ||
  //       (Array.isArray(searchOrgName)
  //         ? searchOrgName.some((searchTerm) =>
  //           orgName.toLowerCase().includes(searchTerm.toLowerCase())
  //         )
  //         : orgName.toLowerCase().includes(searchOrgName.toLowerCase()));
  //     if (!passesOrgFilter) return false;

  //     const passesLocationFilter =
  //       !locationFilter.length || locationFilter.includes(item.locationcount);
  //     if (!passesLocationFilter) return false;

  //     const totalAlerts =
  //       (alarmCounts[item.id]?.warningCount || 0) +
  //       (alarmCounts[item.id]?.errorCount || 0);
  //     const passesAlertFilter =
  //       !alertFilter.length || alertFilter.includes(totalAlerts);

  //     return passesAlertFilter;
  //   });
  // }, [sortedData, searchOrgName, locationFilter, alertFilter, alarmCounts]);

  const dummyData = filteredData
    ?.filter((val) => {
      const kind = val?.tags?.[0]?.kind || val?.kind;
      return kind === "ts.tag.org";
    })
    ?.map((val) => {
      const name = val?.tags?.[0]?.org_name || val?.name || val?.org_name;
      return {
        key: val?.id,
        locationCount: val?.locationcount,
        name: name,
        lastupdated: val?.lastupdated,
        value: val,
        warningCount: alarmCounts[val?.id]?.warningCount,
        errorCount: alarmCounts[val?.id]?.errorCount,
        action: (
          <div style={{ textAlign: "right" }}>
            <Dropdown
              overlay={
                <Menu
                  style={{
                    background: "transparent",
                    boxShadow: "none",
                    padding: 0,
                    border: "none",
                  }}
                >
                  <Menu.Item
                    style={{
                      padding: 0,
                      margin: 0,
                      background: "transparent",
                      border: "none",
                    }}
                  >
                    <ul
                      className="dropdown-menu text-capitalize show"
                      style={{
                        position: "static",
                        background: "#fff",
                        padding: "8px 0",
                        margin: 0,
                        border: "1px solid rgba(0,0,0,0.15)",
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        minWidth: "200px",
                        transform: "none !important",
                      }}
                    >
                      {/* <li>
                        <span
                          className="font-face-vzw ats-filter-header"
                          style={{ marginLeft: "5px" }}
                        >
                          Links
                        </span>
                      </li>
                      {permissions?.Locations?.view && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/locationdetails"
                              state={{
                                filters: true,
                                org_name: val?.tags?.[0]?.org_name,
                                org_id: val?.id,
                              }}
                              className="breadcrums-item_link"
                            >
                              View Locations
                            </Link>
                          </h6>
                        </li>
                      )}
                      {permissions?.assets?.view && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/assets"
                              state={{
                                filters: true,
                                organization:
                                  val?.tags?.[0]?.org_name !== "UNKNOWN"
                                    ? val?.tags?.[0]?.org_name
                                    : "",
                                location:
                                  val?.tags?.[0]?.name !== "UNKNOWN"
                                    ? val?.tags?.[0]?.name
                                    : "",
                                org_id: val?.id,
                                excludeUnknown: true,
                              }}
                              className="breadcrums-item_link"
                            >
                              View Assets
                            </Link>
                          </h6>
                        </li>
                      )}
                      {permissions?.devices?.view && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/devices"
                              state={{
                                filters: true,
                                organizationId: val?.tags?.[0]?.org_name,
                                org_id: val?.id,
                                view: "list",
                              }}
                              className="breadcrums-item_link"
                            >
                              View Devices
                            </Link>
                          </h6>
                        </li>
                      )}
                      {permissions?.alarms?.view && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/alerts"
                              state={{
                                filters: true,
                                organization: val?.tags?.[0]?.org_name,
                                org_id: val?.id,
                                severity: "all",
                              }}
                              className="breadcrums-item_link"
                            >
                              View Alerts
                            </Link>
                          </h6>
                        </li>
                      )} */}
                      <li>
                        {/* <hr
                          className="dropdown-divider"
                          style={{ margin: "8px 0" }}
                        /> */}
                        <span
                          className="font-face-vzw ats-filter-header"
                          style={{ marginLeft: "5px" }}
                        >
                          Actions
                        </span>
                      </li>
                      {permissions?.organizations?.edit && (
                        <li
                          className="dropdown-item"
                          onClick={() => editOrganization(val)}
                          style={{ background: "transparent" }}
                        >
                          <h6>Edit Organization</h6>
                        </li>
                      )}
                      {permissions?.organizations?.edit && (
                        <li
                          className="dropdown-item"
                          onClick={() => deleteOrganization(val)}
                          style={{ background: "transparent" }}
                        >
                          <h6>Delete Organization</h6>
                        </li>
                      )}
                      {/* {permissions?.Locations?.create && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/locationdetails"
                              state={{
                                org_name: val?.tags?.[0]?.org_name,
                                org_id: val?.id,
                                createlocation: true,
                              }}
                              className="breadcrums-item_link"
                            >
                              Add Location
                            </Link>
                          </h6>
                        </li>
                      )}
                      {permissions?.users?.create && (
                        <li
                          className="dropdown-item"
                          style={{ background: "transparent" }}
                        >
                          <h6>
                            <Link
                              to="/users"
                              state={{
                                org_id: val?.id,
                                createuser: true,
                              }}
                              className="breadcrums-item_link"
                            >
                              Add User
                            </Link>
                          </h6>
                        </li>
                      )} */}
                    </ul>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
              placement="bottomRight"
              getPopupContainer={(trigger) => trigger.parentElement}
              overlayStyle={{
                position: "fixed",
              }}
            >
              <a
                className="btn btn-link text-secondary"
                role="button"
                onClick={(e) => e.preventDefault()}
                style={{ position: "relative" }}
              >
                <i className="bi-three-dots-vertical fs-6" />
              </a>
            </Dropdown>
          </div>
        ),
      };
    });
    const handleNameFilter = (e) => {
        dispatch(
            updatePaginationRequest({
              updatedval: "",
              name: { value: e?.filters?.text ? e?.filters?.text : "", sort: e?.isAsc ? "asc" : "desc" },
              pageNo: 0,
            })
          )
        dispatch(
          fetchRequest({ name: e?.filteredResult? e?.filteredResult:[], sort: e?.isAsc ? "asc" : "desc",field:e?.hasOwnProperty("isAsc")?"name":"lastupdated"})
        );
      };
      const handleLastUpdateFilter = (val) => {
          dispatch(
            updatePaginationRequest({
               updatedval: { value: val?.filters?.text ? val?.filters?.text : "", sort: val?.isAsc ? "asc" : "desc" },
               lastUpdatedfrom: val.filters.text[0],
               lastUpdatedto: val.filters.text[1]? dayjs(val.filters.text[1])
                  .set("hour", 23)
                  .set("minute", 59)
                  .set("second", 59)
                  : "",
            })
          );
            dispatch(fetchRequest());
        };
        const handleLastUpdateFilterReset = (val) => {
            dispatch(
              updatePaginationRequest({
                lastUpdatedto: "", 
                lastUpdatedfrom: "",
                sort: "desc",
                field: "createdon",
              })
            );
              dispatch(fetchRequest());
          };
       const handleOrgFilterReset = () => {
          dispatch(
            updatePaginationRequest({
              name: { value: "", sort: "" },
              pageNo: 0,
            })
          );
          dispatch(
          fetchRequest({ name: ""})
        );
        };
  const columns = [
    {
      title: (
        <div>
          <div
            className="input-group input-group-sm d-flex"
            data-controller="qrcode-reader"
            data-action="qrcode:scanned->form#submit"
          >
            <DropdownFilterWithSearch
                          text="Name"
                          isSortable={true}
                          accountId={user?.accountId}
                          onApply={handleNameFilter}
                          onReset={handleOrgFilterReset}
                        />
            {/* <DropdownFilterWithSearchAndCheckbox
              text="Name"
              isSortable={true}
              onApply={handleNameFilter}
              onReset={handleOrgFilterReset}
            /> */}
          </div>
        </div>
      ),
      dataIndex: "name",
      width: 70,
      render: (text, record, index) => {
        return (
          <Box>
            <div
              style={{
                display: "flex",
                fontFamily: "VerizonNHGDS",
                justifyContent: "space-between",
              }}
            >
              <div>
                <button
                  className="custom-link"
                  onClick={() =>
                    permissions?.organizations?.edit
                      ? editOrganization(record?.value)
                      : null
                  }
                >
                  {text}
                </button>
              </div>
            </div>
          </Box>
        );
      },
      SortOrder: "descend",
    },
    {
      title: (
            <div style={{ whiteSpace: "nowrap", padding: "10 20px" }}>
              <div>
                <div className="d-flex table_column_header">
                  <DropdownFilterWithDateRangePicker
                    text="Last updated"
                    isSortable={true}
                    accountId={user?.accountId}
                    onApply={handleLastUpdateFilter}
                    onReset={handleLastUpdateFilterReset}
                  />
                </div>
          </div>
        </div>
      ),
      dataIndex: "lastupdated",
      render: (text) => (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p className="mb-0">{dateFormatWithAt(text)}</p>
              </div>
            </div>
          ),
          SortOrder: "descend",
          width: 70,
        },
    // {
    //   title: (
    //     <div>
    //       <div
    //         className="input-group input-group-sm d-flex"
    //         data-controller="qrcode-reader"
    //         data-action="qrcode:scanned->form#submit"
    //       >
    //         <DropdownFilterWithSearchAndCheckbox
    //           text="Associated locations"
    //           isSortable={true}
    //           onApply={(e) => {
    //             if (!e?.filteredResult) {
    //               setLocationFilter([]);
    //               return;
    //             }
    //             const locationFilters = Array.isArray(e.filteredResult)
    //               ? e.filteredResult.map((loc) => parseInt(loc))
    //               : [parseInt(e.filteredResult)];
    //             setLocationFilter(locationFilters);
    //           }}
    //           onReset={() => {
    //             setLocationFilter([]);
    //             dispatch(fetchRequest());
    //           }}
    //           checkboxItems={Array.from(
    //             new Set(
    //               organizationList
    //                 .filter((item) => item.locationcount)
    //                 .map((item) => item.locationcount)
    //             )
    //           )
    //             .sort((a, b) => a - b)
    //             .map((count) => ({
    //               text: `${count} ${count > 1 ? "Locations" : "Location"}`,
    //               value: count.toString(),
    //             }))}
    //         />
    //       </div>
    //     </div>
    //   ),
    //   width: 100,
    //   render: (text, record, index) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "space-between" }}>
    //         <div>
    //           <p className="mb-0">
    //             {record.locationCount}{" "}
    //             {record.locationCount > 1 ? "Locations" : "Location"}
    //           </p>
    //         </div>
    //       </div>
    //     );
    //   },
    //   SortOrder: "assend",
    // },
    // {
    //   title: (
    //     <div>
    //       <div
    //         className="input-group input-group-sm d-flex"
    //         data-controller="qrcode-reader"
    //         data-action="qrcode:scanned->form#submit"
    //       >
    //         <DropdownFilterWithSearchAndCheckbox
    //           text="Alerts"
    //           isSortable={true}
    //           onApply={(e) => {
    //             if (!e?.filteredResult) {
    //               setAlertFilter([]);
    //               return;
    //             }
    //             const alertFilters = Array.isArray(e.filteredResult)
    //               ? e.filteredResult.map((alert) => parseInt(alert))
    //               : [parseInt(e.filteredResult)];
    //             setAlertFilter(alertFilters);
    //           }}
    //           onReset={() => {
    //             setAlertFilter([]);
    //             dispatch(fetchRequest());
    //             setCheckboxItems(
    //               Array.from(
    //                 new Set(
    //                   organizationList.map(
    //                     (item) =>
    //                       (alarmCounts[item.id]?.warningCount || 0) +
    //                       (alarmCounts[item.id]?.errorCount || 0)
    //                   )
    //                 )
    //               )
    //                 .sort((a, b) => a - b)
    //                 .map((totalAlerts) => ({
    //                   text: `${totalAlerts} ${totalAlerts === 1 ? "Alert" : "Alerts"
    //                     }`,
    //                   value: totalAlerts.toString(),
    //                 }))
    //             );
    //           }}
    //           checkboxItems={checkboxItems}
    //         />
    //       </div>
    //     </div>
    //   ),
    //   width: "85px",
    //   render: (text, record, index) => {
    //     return (
    //       <div>
    //         <turbo-frame>
    //           <Link
    //             to="/devices"
    //             state={{ healthStatus: "WARNING" }}
    //             className="warning-devices-st"
    //           >
    //             {isLoadingAlarmCount ? (
    //               <>
    //                 <Spinner animation="grow" size="sm" />
    //                 <Spinner animation="grow" size="sm" />
    //               </>
    //             ) : (
    //               <>{record.warningCount || 0}</>
    //             )}
    //           </Link>
    //         </turbo-frame>
    //         <turbo-frame>
    //           &nbsp;&nbsp;
    //           <Link
    //             to="/devices"
    //             state={{ healthStatus: "ERROR" }}
    //             className="error-devices-st"
    //           >
    //             {isLoadingAlarmCount ? (
    //               <>
    //                 <Spinner animation="grow" size="sm" />
    //                 <Spinner animation="grow" size="sm" />
    //               </>
    //             ) : (
    //               <>{record.errorCount || 0}</>
    //             )}
    //           </Link>
    //         </turbo-frame>
    //       </div>
    //     );
    //   },
    // },
    {
      title: permissions?.organizations?.download ? (
        <div style={{ textAlign: "right" }}>
          <Dropdown
            placement="bottomRight"
            overlay={
              <Menu
                style={{
                  background: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  border: "none",
                }}
              >
                <Menu.Item
                  style={{
                    padding: 0,
                    background: "transparent",
                    border: "none",
                  }}
                >
                  <ul
                    className="dropdown-menu text-capitalize show"
                    style={{
                      position: "static",
                      background: "#fff",
                      padding: "8px 0",
                      margin: 0,
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderRadius: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      minWidth: "200px",
                      transform: "none !important",
                    }}
                  >
                    <li>
                      <h6
                        className="dropdown-header"
                        style={{ border: "none" }}
                      >
                        Action
                      </h6>
                    </li>
                    <li
                      className="dropdown-item"
                      style={{ background: "transparent" }}
                    >
                      <h6>
                        <span
                          onClick={handleDownload}
                          style={{ cursor: "pointer" }}
                        >
                          Export
                        </span>
                      </h6>
                    </li>
                  </ul>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <button
              className="btn btn-link text-secondary"
              onClick={(e) => e.preventDefault()}
              style={{ position: "relative" }}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </button>
          </Dropdown>
        </div>
      ) : null,
      width: 5,
      dataIndex: "action",
    },
  ];

  return (
    <Box
      sx={{
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopWidth: 0,
      }}
    >
      {orgPopupVisible && (
        <CreateOrganization
          visible={orgPopupVisible}
          closePopup={closeorgPopup}
          state={selectedOrganization}
          onOrgCreated={handleOrgCreatedAdd}
        />
      )}


      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}

      <CustomModal popupName={''} customClass={'deleteAlertGroup'} popupTitle={'Delete Organization'} open={currentModal}>
        <>
          <p style={{ padding: '5px', marginTop: '25px', paddingLeft: '0px' }}>Are you sure you'd like to delete the Organization{" "} <strong>
            {(() => {
              const name = selectedOrganization?.tags?.[0]?.org_name ||
                selectedOrganization?.org_name ||
                selectedOrganization?.tags?.[0]?.name ||
                selectedOrganization?.name ||
                'Unknown Organization';
              return name;
            })()}
          </strong>?</p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%", backgroundColor: "white", color: "black", }}
                  onClick={() => onExit()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    onConfirm()
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>

      <Table
        className="sasp_common-table"
        loading={isLoading}
        style={{ marginTop: "24px" }}
        columns={columns}
        dataSource={dummyData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          total: count,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          prevIcon: ["Previous"],
          nextIcon: ["Next"],
          onChange: (page, pageSize) => {
            dispatch(
              updatePaginationRequest({
                limit: pageSize == -1 ? 10 : pageSize,
                pageNo: page - 1,
              })
            );
            dispatch(fetchRequest());
          },
          showSizeChanger: true,
          locale: {
            items_per_page: "",
          },
        }}
      />
    </Box>
  );
};

export default OrganizationTable;